<template>
  <div class="chart-box">
    <div class="scroll-box" ref="scrollBox">
      <div class="scroll-box-body">
        <Bar
          :styles="myStyles"
          :height="chartHeight"
          :chartOptions="chartOptions"
          :chartData="chartData"
          :plugins="plugins"
          @chart:rendered="rendered"
          ref="bar"
        />

        <div :id="legendId + '-legend-container'"></div>
      </div>
    </div>

    <div class="box">
      <Bar :height="20" :chartOptions="chartOptions2" :chartData="chartData2" />
    </div>
  </div>
</template>

<script>
  const getOrCreateLegendList = (chart, id) => {
    const legendContainer = document.getElementById(id)
    let listContainer = legendContainer.querySelector('ul')

    if (!listContainer) {
      listContainer = document.createElement('ul')
      listContainer.style.display = 'flex'
      listContainer.style.flexDirection = 'row'
      listContainer.style.margin = 0
      listContainer.style.padding = 0
      listContainer.style.marginTop = '65px'

      legendContainer.appendChild(listContainer)
    }

    return listContainer
  }
  import { toRaw } from 'vue'
  import { Bar } from 'vue-chartjs'
  import zoomPlugin from 'chartjs-plugin-zoom'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    // Plugin,
  } from 'chart.js'
  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    zoomPlugin
    // Plugin
  )

  export default {
    name: 'HorizontalStackedBarChart',
    components: {
      Bar,
    },
    computed: {
      myStyles() {
        return { height: `${this.chartHeight}px` }
      },
      suggestedMax() {
        return this.chartData.max
      },
      stepSize() {
        return this.chartData.step
      },
    },
    props: {
      chartData: {
        type: Object,
        default: () => ({}),
      },
      legendId: {
        type: String,
      },
      canScroll: {
        type: Boolean,
        default: () => {
          return true
        },
      },
    },
    watch: {
      suggestedMax: {
        handler: function (newVal) {
          if (this.$refs && this.$refs.bar && this.$refs.bar.chart) {
            this.updateChart()
          }
        },
      },
    },
    mounted() {
      this.$refs.scrollBox.style.overflowY = this.canScroll
        ? 'scroll'
        : 'hidden'
    },
    methods: {
      rendered() {
        const vm = this
        this.$nextTick(() => {
          vm.chartHeight =
            vm.chartData.labels && vm.chartData.labels.length > 5
              ? vm.chartData.labels.length * 48
              : 5 * 48

          vm.chartData2 = { ...vm.chartData, labels: [] }

          setTimeout(() => {
            vm.updateChart()
          }, 100)
        })
      },
      updateChart() {
        this.chartOptions = {
          indexAxis: 'y',
          layout: {
            padding: {
              right: 9.5,
            },
          },
          barThickness: 20,
          // responsive: true,
          maintainAspectRatio: false,
          skipNull: true,
          scales: {
            x: {
              stacked: true,
              suggestedMin: 0,
              suggestedMax: this.suggestedMax,
              grid: {
                drawBorder: false,
                color: '#EAE7DE',
                drawTicks: false,
              },
              ticks: {
                stepSize: this.stepSize,
                display: false,
                // maxTicksLimit: 6,
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 300,
                },
              },
            },
            y: {
              afterFit(scale) {
                scale.width = 240
              },
              stacked: true,
              grid: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 400,
                },
                // callback: function (value, index, ticks_array) {
                //   let characterLimit = 12
                //   let label = this.getLabelForValue(value)
                //   if (label.length >= characterLimit) {
                //     return label
                //     // .slice(0, label.length)
                //     // .substring(0, characterLimit - 1)
                //     // .trim()
                //     //+ '...'
                //   }
                //   return label
                // },
              },
            },
          },
          plugins: {
            htmlLegend: {
              containerID: this.legendId + '-legend-container',
            },
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                boxWidth: 6,
                boxHeight: 6,
                fontColor: '#111',
                usePointStyle: true,
                color: '#67686C',
                font: {
                  size: 14,
                },
              },
            },
            datalabels: {
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0
              },
            },
          },
        }

        this.chartOptions2 = {
          indexAxis: 'y',
          // barThickness: 20,
          // responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: true,
              suggestedMin: 0,
              suggestedMax: this.suggestedMax,
              grid: {
                drawBorder: false,
                // color: '#EAE7DE',
                display: false,
                drawTicks: false,
              },
              ticks: {
                stepSize: this.stepSize,
                // maxTicksLimit: 6,
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 300,
                },
              },
              afterFit(scale) {
                scale.height += 30
              },
            },
            y: {
              afterFit(scale) {
                scale.width = 240
              },
              //     stacked: true,
              grid: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 400,
                },
                //       callback: function (value, index, ticks_array) {
                //         return ''
                //       },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        }
        this.$refs.bar.chart.update()
      },
    },
    data() {
      return {
        chartHeight: 0,
        chartData2: {},
        plugins: [
          {
            id: 'htmlLegend',
            afterUpdate(chart, args, options) {
              const ul = getOrCreateLegendList(chart, options.containerID)
              ul.style.display = 'grid'
              ul.style.gridTemplateColumns = '1fr 1fr 1fr 1fr 1fr 1fr'
              ul.style.gridGap = '8px'
              ul.style.position = 'absolute'
              ul.style.right = 0
              ul.style.bottom = 0
              ul.style.width = '100%'
              ul.style.paddingLeft = '88px'

              // Remove old legend items
              while (ul.firstChild) {
                ul.firstChild.remove()
              }

              // Reuse the built-in legendItems generator
              const items =
                chart.options.plugins.legend.labels.generateLabels(chart)

              items.forEach((item) => {
                const li = document.createElement('li')
                li.style.alignItems = 'center'
                li.style.cursor = 'pointer'
                li.style.display = 'flex'
                li.style.flexDirection = 'row'
                li.style.marginLeft = '10px'

                li.onclick = () => {
                  const { type } = chart.config
                  if (type === 'pie' || type === 'doughnut') {
                    // Pie and doughnut charts only have a single dataset and visibility is per item
                    chart.toggleDataVisibility(item.index)
                  } else {
                    chart.setDatasetVisibility(
                      item.datasetIndex,
                      !chart.isDatasetVisible(item.datasetIndex)
                    )
                  }
                  chart.update()
                }

                // Color box
                const boxSpan = document.createElement('span')
                boxSpan.style.background = item.fillStyle
                boxSpan.style.borderColor = item.strokeStyle
                boxSpan.style.borderWidth = item.lineWidth + 'px'
                boxSpan.style.display = 'inline-block'
                boxSpan.style.height = '9px'
                boxSpan.style.marginRight = '10px'
                boxSpan.style.width = '9px'
                boxSpan.style.borderRadius = '4.5px'

                // Text
                const textContainer = document.createElement('p')
                textContainer.style.color = item.fontColor
                textContainer.style.margin = 0
                textContainer.style.padding = 0
                textContainer.style.textDecoration = item.hidden
                  ? 'line-through'
                  : ''

                const text = document.createTextNode(item.text)
                textContainer.appendChild(text)

                li.appendChild(boxSpan)
                li.appendChild(textContainer)
                ul.appendChild(li)
              })
            },
          },
          {
            id: 'moveChart',
            afterDraw(chart, args, pluginOptions) {
              const {
                ctx,
                chartArea: { left, right, top, bottom, width, height },
              } = chart
            },
          },
          {
            id: 'innerBarText',
            afterDatasetsDraw(chart, args, pluginOptions) {
              const {
                ctx,
                data,
                chartArea: { left },
                scales: { x, y },
              } = chart
              ctx.save()

              ctx.font = 'bolder 12px sans-serif'
              ctx.fillStyle = 'gray'
              // ctx.fillText('test', 10, 10)
            },
          },
          ChartDataLabels,
        ],
        chartOptions: {
          indexAxis: 'y',
          layout: {
            padding: {
              right: 9.5,
            },
          },
          barThickness: 20,
          // responsive: true,
          maintainAspectRatio: false,
          skipNull: true,
          scales: {
            x: {
              stacked: true,
              grid: {
                drawBorder: false,
                color: '#EAE7DE',
                drawTicks: false,
              },
              ticks: {
                display: false,
                // maxTicksLimit: 6,
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 300,
                },
              },
            },
            y: {
              afterFit(scale) {
                scale.width = 240
              },
              stacked: true,
              grid: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 400,
                },
                callback: function (value, index, ticks_array) {
                  let characterLimit = 12
                  let label = this.getLabelForValue(value)
                  if (label.length >= characterLimit) {
                    return label
                      .slice(0, label.length)
                      .substring(0, characterLimit - 1)
                      .trim()
                    // + '...'
                  }
                  return label
                },
              },
            },
          },
          plugins: {
            htmlLegend: {
              containerID: this.legendId + '-legend-container',
            },
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                boxWidth: 6,
                boxHeight: 6,
                fontColor: '#111',
                usePointStyle: true,
                color: '#67686C',
                font: {
                  size: 14,
                },
              },
            },
            datalabels: {
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0
              },
            },
          },
        },
        chartOptions2: {
          indexAxis: 'y',
          // barThickness: 20,
          // responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              stacked: true,
              grid: {
                drawBorder: false,
                // color: '#EAE7DE',
                display: false,
                drawTicks: false,
              },
              ticks: {
                // maxTicksLimit: 6,
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 300,
                },
              },
              afterFit(scale) {
                scale.height += 30
              },
            },
            y: {
              afterFit(scale) {
                scale.width = 240
              },
              //     stacked: true,
              grid: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                color: '#8B8D97',
                font: {
                  size: 12,
                  weight: 400,
                },
                //       callback: function (value, index, ticks_array) {
                //         return ''
                //       },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      }
    },
  }
</script>

<style lang="less" scoped>
  .chart-box {
    position: relative;
    padding-bottom: 80px;

    .scroll-box {
      height: 480px;
      max-height: 240px;
      overflow-y: scroll;
    }
  }

  .box {
    height: 20px;
    // max-height: 100px;
    // background-color: red;
    // overflow-y: scroll;
  }
</style>
